import { IHttpResponse } from "app_types/httpTypes";

export enum BUY_ACTION {
  FOR_MYSELF = "for_myself",
  FOR_OTHERS = "for_others",
  FOR_ME_AND_OTHERS = 'for_me_and_others'
};
export interface IShoppingCarItem {
  identifier: string,
  externalId: string,
  programCode: string,
  image: string,
  description: string,
  price: string,
  priceNumeric: number,
  startDate: string,
  modality: string,
  priceWithDiscount?: string | null,
  priceWithDiscountNumeric?: number | null,
  numberOfPlaces: number;
  dateOfAddition: number | null;
  buyAction: BUY_ACTION;
}

export enum PROCESS_PURCHASE {
  VERIFY_PURCHASE = 'verify_purchase',
  REDIRECT = 'redirect'
}

export enum PROCESS_ITEM_PURCHASE {
  WARNING = 'warning',
  RESTRICTED = 'restricted',
  AVAILABLE = 'available',
}

export interface IBuyCoursesResponse extends IHttpResponse {
  processPurchase: PROCESS_PURCHASE,
  review?: Record<string, IObjectToBuy>
  redirectUrl?: string
};

export interface IObjectToBuy {
  processPurchase: PROCESS_ITEM_PURCHASE
  reason: string,
  programCode: string,
  programName: string,
  identifier: string,
  externalId: string,
  removed?: boolean
}
